import React from 'react';

import { Animate } from 'react-move';

const FadeWrapper = ({ isShow, children }: { isShow: boolean; children: React.ReactNode }) => {
  return (
    <Animate
      show={isShow}
      start={{ opacity: 0 }}
      enter={{
        opacity: [1],
        timing: { duration: 200 },
      }}
      leave={{
        opacity: [0],
        timing: { duration: 200 },
      }}
    >
      {({ opacity }) => <div style={{ opacity }}>{children}</div>}
    </Animate>
  );
};

export { FadeWrapper };
